var React = require('react');

function FlagFi16 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_67_516)","key":0},[React.createElement("rect",{"width":"26","height":"16","rx":"1","fill":"white","key":0}),React.createElement("path",{"d":"M26 6H0V10H26V6Z","fill":"#002F6C","key":1}),React.createElement("path",{"d":"M11 0H7V16H11V0Z","fill":"#002F6C","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_67_516"},React.createElement("rect",{"width":"26","height":"16","rx":"1","fill":"white"})))]);
}

FlagFi16.defaultProps = {"width":"26","height":"16","viewBox":"0 0 26 16","fill":"none"};

module.exports = FlagFi16;

FlagFi16.default = FlagFi16;
